import { UserOutlined } from '@ant-design/icons'
import { Radio } from 'antd'
import moment from 'moment'
import React from 'react'
import { Preference } from './Merge.index'

export default function BasicInfoSection({
    guest = {},
    isPrimary,
    basicInforPreferences,
    onBasicInfoPreferenceChange,
    customerId
}) {

    const type = isPrimary ? Preference.Primary : Preference.Secondary

    return (
        <div style={{
            border: '1px solid #e2e4e9',
            borderRadius: 6,
            marginBottom: 16
        }}>
            <div
                style={{
                    borderBottom: '1px solid #e2e4e9',
                    padding: 8,
                    background: '#f0f2f44d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8
                }}
            >
                <UserOutlined />
                <span style={{
                    fontWeight: 600,
                    fontFamily: 'tradeGothic',
                    fontSize: 14
                }}>
                    Basic Information (#{customerId})
                </span>
            </div>
            <div style={{ padding: 8 }}>
                <div>
                    <div style={{
                        fontFamily: 'tradeGothic',
                        color: '#737b8c',
                        fontSize: 11,
                        fontWeight: 600
                    }}>
                        Username
                    </div>
                    <div>
                        <Radio
                            defaultChecked={isPrimary}
                            checked={
                                basicInforPreferences.userName === type
                            }
                            onChange={(e) => {
                                onBasicInfoPreferenceChange('userName', type)
                            }}
                        />
                        <span
                            style={{
                                fontFamily: 'tradeGothic'
                            }}
                        >{guest.userName}</span>
                    </div>
                </div>
                <div>
                    <div style={{
                        fontFamily: 'tradeGothic',
                        color: '#737b8c',
                        fontSize: 11,
                        fontWeight: 600
                    }}>
                        Email
                    </div>
                    <div>
                        <Radio
                            defaultChecked={isPrimary}
                            checked={
                                basicInforPreferences.email === type
                            }
                            onChange={(e) => {
                                onBasicInfoPreferenceChange('email', type)
                            }}

                        />
                        <span
                            style={{
                                fontFamily: 'tradeGothic'
                            }}
                        >{guest.email}</span>

                    </div>
                </div>
                <div>
                    <div style={{
                        fontFamily: 'tradeGothic',
                        color: '#737b8c',
                        fontSize: 11,
                        fontWeight: 600
                    }}>DOB</div>
                    <div>
                        <Radio
                            defaultChecked={isPrimary}
                            checked={
                                basicInforPreferences.dob === type
                            }
                            onChange={(e) => {
                                onBasicInfoPreferenceChange('dob', type)
                            }}

                        />
                        <span
                            style={{
                                fontFamily: 'tradeGothic'
                            }}
                        >
                            {guest.dob ? moment(guest.dob, "YYYY-MM-DD").format('DD MMM YYYY') : ""}
                        </span>
                    </div>
                </div>
                <div>
                    <div style={{
                        fontFamily: 'tradeGothic',
                        color: '#737b8c',
                        fontSize: 11,
                        fontWeight: 600
                    }}>Flag</div>
                    <div>
                        <Radio
                            defaultChecked={isPrimary}
                            checked={
                                basicInforPreferences.flag === type
                            }
                            onChange={(e) => {
                                onBasicInfoPreferenceChange('flag', type)
                            }}

                        />
                        <span style={{
                            fontFamily: 'tradeGothic'
                        }}>{guest?.isCustomerProfileFlagged ? "Flagged": "Unflagged"}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
